import useGetApi from '../useGetApi';
import {
  RebateInvoicesResponse,
  RebateInvoiceDetail,
  InvoiceFilters,
} from './types';

// Get invoices for a rebate agreement
export const useRebateInvoicesByAgreement = (
  agreementId: string,
  filters?: InvoiceFilters,
  enabled = true,
) => {
  const queryParams = new URLSearchParams();

  if (filters?.startDate) queryParams.append('startDate', filters.startDate);
  if (filters?.endDate) queryParams.append('endDate', filters.endDate);
  if (filters?.limit) queryParams.append('limit', filters.limit.toString());
  if (filters?.offset) queryParams.append('offset', filters.offset.toString());

  const queryString = queryParams.toString();
  const endpoint = `rebates/invoices/agreement/${agreementId}${
    queryString ? `?${queryString}` : ''
  }`;

  return useGetApi<RebateInvoicesResponse>({
    endpoint,
    options: {
      enabled: enabled && !!agreementId,
    },
  });
};

// Get detailed invoice information
export const useRebateInvoiceDetail = (invoiceId: string) => {
  return useGetApi<RebateInvoiceDetail>({
    endpoint: `rebates/invoices/${invoiceId}`,
    options: {
      enabled: !!invoiceId,
    },
  });
};
